const state = {
    tabName: 'PersonConfig',
}

const mutations = {
    setTabName(state, name){
        state.tabName = name;
    },
}

const actions = {
    setTabNameAction({ commit }, name) {
        commit('setTabName', name)
    }
}


const quota = {
    namespaced: true,
    state,
    mutations,
    actions
}

export default quota;